(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jf-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jf-bundle')) {
    customElements.define('jf-bundle', class extends HTMLElement {
      connectedCallback() {
        try { this.variants = JSON.parse(this.dataset.variants); } catch (e) { this.variants = []; }
        this.byId = Object.fromEntries(this.variants.map((v) => [String(v.id), v]));
        this.current = this.dataset.current;
        this.tiers = [...this.querySelectorAll('.jf-bundle__tier')];
        this.tiers.forEach((t) => t.querySelector('.jf-bundle__radio').addEventListener('change', () => this.select(t)));
        this.ac = new AbortController();
        const { signal } = this.ac;
        const onVariant = (e) => {
          const done = (v) => { if (v && v.id) { this.current = String(v.id).split('/').pop(); this.update(); } };
          if (e && e.promise && e.promise.then) e.promise.then((r) => done(r && r.detail && r.detail.resource || r && r.variant)).catch(() => {});
          else done(e && e.detail && (e.detail.resource || e.detail.variant));
        };
        ['shopify:product:select', 'variant:update', 'variant:change'].forEach((n) => document.addEventListener(n, onVariant, { signal }));
        document.addEventListener('change', (e) => {
          if (e.target && e.target.closest && e.target.closest('variant-picker, swatches-variant-picker-component')) setTimeout(() => this.syncFromForm(), 700);
        }, { signal });
        document.addEventListener('click', (e) => {
          if (e.target && e.target.closest && e.target.closest('.quantity-plus, .quantity-minus')) setTimeout(() => this.syncFromForm(), 0);
        }, { signal });
        document.addEventListener('change', (e) => { if (e.target && e.target.name === 'quantity') this.syncFromForm(); }, { signal });
        const checked = this.tiers.find((t) => t.querySelector('.jf-bundle__radio').checked) || this.tiers[0];
        if (checked) this.select(checked);
        if (this.classList.contains('jf-bundle--hides-qty')) { const w = this.section().querySelector('.quantity-selector-wrapper'); if (w) w.style.display = 'none'; }
        customElements.whenDefined('quantity-selector-component').then(() => this.selected && this.select(this.selected)).catch(() => {});
        customElements.whenDefined('product-form-component').then(() => this.selected && this.select(this.selected)).catch(() => {});
      }
      disconnectedCallback() { this.ac && this.ac.abort(); }
      section() { return document.getElementById('shopify-section-' + this.dataset.section) || this.closest('.shopify-section') || document; }
      form() { return this.section().querySelector('product-form-component form, form[action*="/cart/add"]'); }
      qtyComponent() { return this.section().querySelector('quantity-selector-component'); }
      qtyInput() { return this.section().querySelector('quantity-selector-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]'); }
      hiddenQty() {
        const f = this.form(); if (!f) return null;
        let h = f.querySelector('input[name="quantity"][data-jf]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'quantity'; h.dataset.jf = '1'; f.appendChild(h); }
        return h;
      }
      syncFromForm() {
        const f = this.form();
        const idInput = f && f.querySelector('input[name="id"]');
        if (idInput && idInput.value && idInput.value !== this.current) { this.current = idInput.value; this.update(); }
        const q = this.qtyInput(); const n = q && parseInt(q.value, 10);
        if (n) this.highlight(n);
      }
      select(tier) {
        this.tiers.forEach((t) => t.classList.toggle('is-selected', t === tier));
        tier.querySelector('.jf-bundle__radio').checked = true;
        this.selected = tier;
        this.update();
        const qty = parseInt(tier.dataset.qty, 10) || 1;
        const comp = this.qtyComponent(); const input = this.qtyInput();
        if (comp && typeof comp.setValue === 'function') {
          comp.setValue(String(qty));
          if (typeof comp.updateButtonStates === 'function') comp.updateButtonStates();
          if (typeof comp.onQuantityChange === 'function') comp.onQuantityChange();
        } else if (input) {
          input.value = qty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const h = this.hiddenQty(); if (h) h.value = qty;
          const pf = this.section().querySelector('product-form-component'); if (pf) pf.dataset.quantityDefault = String(qty);
        }
      }
      highlight(qty) {
        const match = this.tiers.find((t) => parseInt(t.dataset.qty, 10) === qty);
        this.tiers.forEach((t) => t.classList.toggle('is-selected', t === match));
        if (match) { match.querySelector('.jf-bundle__radio').checked = true; this.selected = match; }
      }
      totals(tier) {
        const v = this.byId[this.current] || this.variants[0] || { price: 0, compare: 0 };
        const qty = parseInt(tier.dataset.qty, 10) || 1;
        const off = parseFloat(tier.dataset.off) || 0;
        const full = v.price * qty;
        // Match Shopify's automatic discount: the percentage is taken per unit and the discount is rounded DOWN
        // (10% of $34.99 = $3.49 off, so $31.50 each), not rounded on the total. Otherwise button and cart disagree by cents.
        const unit = v.price - Math.floor((v.price * off) / 100);
        return { price: unit * qty, compare: Math.max(v.compare, v.price) * qty, qty };
      }
      money(cents) {
        const fmt = this.dataset.money || ('$' + '{' + '{amount}' + '}');
        const n = cents / 100, two = n.toFixed(2), zero = Math.round(n).toString();
        const th = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        return fmt.replace(/\{\{\s*amount\s*\}\}/, th(two, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, th(zero, ','))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, th(two.replace('.', ','), '.')).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, th(zero, '.'))
          .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, th(two, "'")).replace(/<[^>]*>/g, '');
      }
      update() {
        this.tiers.forEach((t) => {
          const { price, compare, qty } = this.totals(t);
          t.querySelector('[data-price]').textContent = this.money(price);
          t.querySelector('[data-compare]').textContent = compare > price ? this.money(compare) : '';
          t.querySelector('[data-each]').textContent = qty > 1 ? this.money(Math.round(price / qty)) + ' each' : '';
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jf-low-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jf-low-stock')) {
    customElements.define('jf-low-stock', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.visitor = this.constructor.visitorId();
        try { this.variants = Object.fromEntries(JSON.parse(this.dataset.inventory).map((v) => [String(v.id), v])); }
        catch { this.variants = {}; }
        this.render(this.currentId());

        const signal = this.controller.signal;
        document.addEventListener('visibilitychange', () => { if (!document.hidden && this.isConnected) this.render(this.currentId()); }, { signal });
        const sync = () => { if (this.isConnected) this.render(this.currentId()); };
        // Horizon re-renders the product section on variant change, so the
        // hidden id input is the one source that is always current.
        const nudge = () => { sync(); requestAnimationFrame(sync); setTimeout(sync, 120); setTimeout(sync, 400); };
        ['change', 'input', 'click'].forEach((name) => {
          document.addEventListener(name, (event) => {
            const el = event.target;
            if (el?.closest?.('variant-picker, variant-selects, swatches-variant-picker-component, .jf-bundle')) nudge();
          }, { signal, capture: true });
        });
        ['shopify:product:select', 'variant:update', 'variant:change', 'variantupdate'].forEach((name) => {
          document.addEventListener(name, nudge, { signal });
        });
        const form = this.scope().querySelector('form[action*="/cart/add"]');
        if (form) {
          this.observer?.disconnect();
          this.observer = new MutationObserver(nudge);
          this.observer.observe(form, { subtree: true, attributes: true, attributeFilter: ['value'], childList: true });
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
      scope() { return this.closest('.shopify-section') || document; }
      currentId() {
        const input = this.scope().querySelector('form[action*="/cart/add"] input[name="id"], variant-selects input[name="id"]');
        const id = input?.value && String(input.value).split('/').pop();
        return id || this.dataset.variant;
      }
      static visitorId() {
        const key = 'jf-stock-visitor';
        try {
          let id = localStorage.getItem(key);
          if (!id) { id = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); localStorage.setItem(key, id); }
          return id;
        } catch { return 'anon'; }
      }
      countFor(id) {
        const a = Number(this.dataset.countMin), b = Number(this.dataset.countMax);
        const lo = Math.min(a, b), hi = Math.max(a, b);
        if (!Number.isFinite(lo) || !Number.isFinite(hi)) return hi || lo || 0;
        if (hi <= lo) return lo;
        // Stable per visitor and per variant: same number on reload, a
        // different one for each variant and each visitor.
        const key = this.visitor + ':' + id;
        let h = 2166136261;
        for (let i = 0; i < key.length; i++) { h ^= key.charCodeAt(i); h = Math.imul(h, 16777619); }
        return this.decayed(id, lo + (Math.abs(h) % (hi - lo + 1)));
      }
      // Countdown: the visitor's starting number drops by 1 every `decay-minutes` since they first saw this
      // variant, never below `count-floor`. First-seen time lives in localStorage so it survives reloads and
      // never jumps back up mid-visit; after `reset-hours` the visitor starts over.
      decayed(id, base) {
        const every = Number(this.dataset.decayMinutes) * 60000;
        const floor = Math.max(1, Number(this.dataset.countFloor) || 1);
        this.nextTick = 0;
        if (!(every > 0) || base <= floor) return base;
        const now = Date.now(), resetAfter = (Number(this.dataset.resetHours) || 24) * 3600000, key = 'jf-stock-seen';
        let seen = {};
        try { seen = JSON.parse(localStorage.getItem(key)) || {}; } catch {}
        if (typeof seen !== 'object' || Array.isArray(seen)) seen = {};
        let since = Number(seen[id]);
        if (!(since > 0) || since > now || now - since >= resetAfter) {
          since = now; seen[id] = since;
          try { localStorage.setItem(key, JSON.stringify(seen)); } catch { this.memorySeen = this.memorySeen || {}; since = this.memorySeen[id] = this.memorySeen[id] || now; }
        }
        const steps = Math.floor((now - since) / every);
        const count = Math.max(floor, base - steps);
        // when the next drop (or the reset) is due, so the number changes live without a reload
        this.nextTick = count > floor ? since + (steps + 1) * every : since + resetAfter;
        return count;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.nextTick) return;
        const wait = Math.min(Math.max(this.nextTick - Date.now(), 0) + 250, 2147000000);
        this.timer = setTimeout(() => { if (this.isConnected) this.render(this.currentId()); }, wait);
      }
      // render() is nudged many times per variant change; only touch the DOM when something actually changed.
      paint(text, value, id, state) {
        if (text.textContent !== value) text.textContent = value;
        if (this.dataset.variant !== String(id)) this.dataset.variant = id;
        if (this.dataset.state !== state) this.dataset.state = state;
        if (this.hidden) this.hidden = false;
      }
      render(id) {
        const variant = this.variants[String(id)];
        const text = this.querySelector('.jf-stock__text');
        if (!text) return;
        if (variant?.available === false) {
          text.textContent = this.dataset.soldOut.replaceAll('[variant]', variant.title);
          this.dataset.variant = id;
          this.dataset.state = 'sold-out';
          this.hidden = false;
          return;
        }

        if (this.dataset.mode !== 'auto') {
          const title = variant?.title;
          if (!title) return;
          this.paint(text, this.dataset.template
            .replaceAll('[count]', String(this.countFor(id)))
            .replaceAll('[variant]', title), id, 'low');
          this.schedule();
          return;
        }

        if (!variant) return;
        const low = variant.available && variant.tracked && variant.policy === 'deny' && variant.quantity > 0 && variant.quantity <= Number(this.dataset.threshold || 15);
        const template = !variant.available ? this.dataset.soldOut : low ? this.dataset.template : this.dataset.inStock;
        text.textContent = template.replaceAll('[count]', String(variant.quantity)).replaceAll('[variant]', variant.title);
        this.dataset.variant = id;
        this.dataset.state = !variant.available ? 'sold-out' : low ? 'low' : 'in-stock';
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jf-pairs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jf-pairs')) customElements.define('jf-pairs', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.jf-pairs__add').forEach((btn) => btn.addEventListener('click', () => this.add(btn)));
    }
    async add(btn) {
      const id = btn.dataset.variantId; btn.disabled = true;
      try {
        const actions = window.Shopify && window.Shopify.actions;
        if (actions && typeof actions.updateCart === 'function') {
          const r = await actions.updateCart({ lines: [{ merchandiseId: id, quantity: 1 }] }, { event: { context: 'product' } });
          if (r && r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
          if (typeof actions.openCart === 'function') actions.openCart().catch(() => {});
        } else {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) });
          if (!res.ok) throw new Error('Could not add');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        }
        btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1500);
      } catch (e) { btn.style.borderColor = '#B42318'; setTimeout(() => { btn.style.borderColor = ''; }, 1500); }
      finally { btn.disabled = false; }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jf-product-head"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jf-product-head')) customElements.define('jf-product-head', class extends HTMLElement {
    connectedCallback() {
      try { this.v = JSON.parse(this.dataset.variants); } catch (e) { this.v = []; }
      const on = (e) => { const done = (r) => { const id = r && (r.detail && r.detail.resource && r.detail.resource.id || r.variant && r.variant.id); if (id) this.render(String(id).split('/').pop()); }; if (e && e.promise) e.promise.then(done).catch(() => {}); else done(e); };
      ['shopify:product:select', 'variant:update', 'variant:change'].forEach((n) => document.addEventListener(n, on));
      const mirror = () => { const sec = this.closest('.shopify-section') || document; const sel = sec.querySelector('.jf-bundle__tier.is-selected [data-price]'); const btn = sec.querySelector('.product-details button[type="submit"]'); if (!sel || !btn) return; let sp = btn.querySelector('.jf-atc-total'); if (!sp) { sp = document.createElement('span'); sp.className = 'jf-atc-total'; btn.appendChild(sp); } sp.textContent = sel.textContent; };
      const b = (this.closest('.shopify-section') || document).querySelector('.jf-bundle'); if (b) { new MutationObserver(mirror).observe(b, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] }); setTimeout(mirror, 300); }
      document.addEventListener('change', (ev) => { if (ev.target.closest && ev.target.closest('variant-picker, swatches-variant-picker-component')) setTimeout(() => { const f = this.closest('.shopify-section')?.querySelector('form[action*="/cart/add"] input[name="id"]'); if (f) this.render(f.value); }, 700); });
    }
    money(c) { const f = this.dataset.money || ('$' + '{' + '{amount}' + '}'); const n = (c / 100).toFixed(2); return f.replace(/\{\{\s*amount\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/<[^>]*>/g, ''); }
    render(id) { const x = this.v.find((y) => String(y.id) === String(id)); if (!x) return; this.querySelector('[data-price]').textContent = this.money(x.price); const has = x.compare > x.price; const was = this.querySelector('[data-compare]'), save = this.querySelector('[data-save]'); was.hidden = !has; save.hidden = !has; if (has) { was.textContent = this.money(x.compare); this.querySelector('[data-save-amt]').textContent = this.money(x.compare - x.price); } }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jf-promo-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jf-countdown')) {
    customElements.define('jf-countdown', class extends HTMLElement {
      connectedCallback() {
        this.units = {};
        this.querySelectorAll('[data-u]').forEach((el) => (this.units[el.dataset.u] = el));
        const code = this.querySelector('.jf-promo__code');
        if (code) code.addEventListener('click', async () => {
          const value = code.dataset.code;
          const c = this.querySelector('.jf-promo__copied');
          let ok = false;
          try { await navigator.clipboard.writeText(value); ok = true; }
          catch {
            // In-app browsers (Instagram, Facebook) often lack or block the async clipboard API.
            const ta = document.createElement('textarea');
            ta.value = value; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
            document.body.append(ta); ta.select();
            try { ok = document.execCommand('copy'); } catch {}
            ta.remove();
          }
          // Only claim success when the code really reached the clipboard.
          if (c) { c.textContent = ok ? 'Copied' : 'Type ' + value + ' at checkout'; setTimeout(() => (c.textContent = ''), ok ? 1800 : 4000); }
        });
        this.end = this.resolveEnd();
        this.publish();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      resolveEnd() {
        if (this.dataset.mode === 'fixed' && this.dataset.end) {
          const t = new Date(this.dataset.end.replace(' ', 'T')).getTime();
          return isNaN(t) ? 0 : t;
        }
        const hours = parseFloat(this.dataset.hours || '24');
        const key = this.dataset.key;
        let end = 0;
        try { end = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
        if (!end || end < Date.now()) {
          end = Date.now() + hours * 3600 * 1000;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
        }
        return end;
      }
      // The cart drawer countdown reads this, so the heading, end time and colors are edited in one place: this block.
      publish() {
        const heading = this.querySelector('.jf-promo__heading');
        const css = (v) => this.style.getPropertyValue(v).trim();
        try {
          localStorage.setItem('jf-promo-live', JSON.stringify({
            end: this.end, heading: heading ? heading.textContent.trim() : '', bg: css('--bg'), fg: css('--fg'), accent: css('--accent')
          }));
        } catch (e) {}
      }
      tick() {
        let diff = this.end - Date.now();
        if (diff <= 0) {
          if (this.dataset.mode === 'evergreen') { this.end = this.resolveEnd(); this.publish(); diff = this.end - Date.now(); }
          else if (this.dataset.expired === 'hide') { this.hidden = true; clearInterval(this.timer); return; }
          else diff = 0;
        }
        const s = Math.floor(diff / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        this.units.d.textContent = pad(Math.floor(s / 86400));
        this.units.h.textContent = pad(Math.floor((s % 86400) / 3600));
        this.units.m.textContent = pad(Math.floor((s % 3600) / 60));
        this.units.s.textContent = pad(s % 60);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jf-variant-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jf-variant-cards')) customElements.define('jf-variant-cards', class extends HTMLElement {
    connectedCallback() {
      this.section = () => document.getElementById('shopify-section-' + this.dataset.section) || this.closest('.shopify-section') || document;
      const hide = () => { const n = this.section().querySelector('variant-picker, swatches-variant-picker-component'); if (n) { const wrap = n.closest('.product-details__block, [class*="variant-picker"]') || n; wrap.style.display = 'none'; } };
      hide(); customElements.whenDefined('variant-picker').then(hide).catch(() => {});
      this.querySelectorAll('.jf-vc__card').forEach((c) => c.addEventListener('click', () => this.pick(c.dataset.value)));
      const sync = (title) => { this.querySelectorAll('.jf-vc__card').forEach((c) => { const on = c.dataset.value === title; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); }); this.querySelector('[data-current]').textContent = title; };
      document.addEventListener('shopify:product:select', (e) => e.promise && e.promise.then((r) => { const t = r && r.detail && r.detail.resource && r.detail.resource.title; if (t) sync(t); }).catch(() => {}));
    }
    pick(val) {
      const n = this.section(); const input = [...n.querySelectorAll('variant-picker input[type="radio"], swatches-variant-picker-component input[type="radio"]')].find((i) => i.value === val);
      if (input) {
        // click() on an unchecked radio already fires a native change. Dispatching a second one made Horizon
        // fetch the section twice and abort the first request on every selection. Only fall back if none fired.
        let fired = false; const seen = () => { fired = true; };
        input.addEventListener('change', seen, { once: true }); input.click(); input.removeEventListener('change', seen);
        if (!fired && input.checked) input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      else { const sel = n.querySelector('variant-picker select'); if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); } }
      this.querySelectorAll('.jf-vc__card').forEach((c) => { const on = c.dataset.value === val; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); }); this.querySelector('[data-current]').textContent = val;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
